import React from "react";

export default function ContractSummaryInfoHeader() {
  return (
    <thead role="rowgroup">
      <tr role="row">
        <th id="group" role="columnheader">
          Group
        </th>
        <th id="ch" className="text-center" role="columnheader">
          Contract Holders
        </th>
        <th id="ch" className="text-center" role="columnheader">
          Contracts
        </th>
      </tr>
    </thead>
  );
}
